import { RootState, useAppDispatch, useAppSelector } from "../../redux/AppStore";
import { updateCustomerPhone } from "../../redux/slice/UpdateTrackingAddressSlice";

export default function CustomerPhoneComponent() {
    const customerPhone:string = useAppSelector((state: RootState) => state.updateAddress.newuserData.shipment_customer_phone);
    const dispatch = useAppDispatch();

    return (
        <div className="UpdateVerifyInput">
            <label>Contact No.</label>
            <input type="tel" className="form-control" placeholder="Contact No." value={customerPhone} onChange={t => 
                 {
                    dispatch(
                        updateCustomerPhone(t.target.value),
                      );
                }
            } />
        </div>
    );
}